import { BugReport, Face as FaceIcon, Factory, ExitToApp as LogoutIcon, Tune as PreferencesIcon, Star, Visibility } from '@mui/icons-material';
import { Box, Divider, IconButton, IconButtonProps, List, ListItemButton, ListItemIcon, ListItemText, Popover, SxProps, Typography } from "@mui/material";
import { useStore } from '@priolo/jon';
import { FunctionComponent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getUrlByPageId } from 'stores/route/utils/pagesId';
import { PAGE_ID } from 'stores/route/utils/types';
import userSo from 'stores/user';

const isPLC = import.meta.env.VITE_TARGET == "plc"



const UserButton: FunctionComponent<IconButtonProps> = (props) => {

	// STORE
	const userSa = useStore(userSo)

	// HOOKs
	const { t } = useTranslation()
	const anchorRef = useRef()
	const history = useHistory()


	// HANDLEs
	const handleOpen = () => userSo.setMenuOpen(true)

	const handleClose = () => userSo.setMenuOpen(false)

	const handleLogout = async () => {
		await userSo.logout({ reload: true })
	}

	const handlePreferences = () => {
		history.push(getUrlByPageId(PAGE_ID.PREFERENCES))
		userSo.setMenuOpen(false)
	}


	// RENDER
	if (!userSo.isLogged()) return null

	return <>

		<IconButton
			onClick={handleOpen}
			ref={anchorRef}
			{...props}
		>
			<FaceIcon fontSize='medium' />
		</IconButton>

		<Popover
			open={userSa.menuOpen}
			anchorEl={anchorRef.current}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
		>
			<Box sx={{ display: "flex", flexDirection: "column" }} >

				<Box sx={{ display: "flex", flexDirection: "column", m: "20px", gap: "5px" }} >
					<Typography color="secondary">{userSa.current.email}</Typography>
					<Box sx={{ display: "flex", alignItems: "center", gap: .1 }}>
						<Typography sx={{ flex: 1 }}>{userSa.current.name}</Typography>
						{userSo.isAdmin() && <Star sx={sxBadgeIcon} />}
						{userSo.isDebugger() && <BugReport sx={sxBadgeIcon} />}
						{userSo.plcAccess() && <Factory sx={sxBadgeIcon} />}
						{userSo.state.current?.role == "reader" && <Visibility sx={sxBadgeIcon} />}
					</Box>
				</Box>

				<Divider />

				<List dense>

					{!isPLC && (
						<ListItemButton onClick={handlePreferences}>
							<ListItemIcon sx={{ minWidth: 36 }}><PreferencesIcon /></ListItemIcon>
							<ListItemText sx={sxMenuLabel} primary={t("dialog.user.preferences")} />
						</ListItemButton>
					)}

					<ListItemButton onClick={handleLogout}>
						<ListItemIcon sx={{ minWidth: 36 }}><LogoutIcon /></ListItemIcon>
						<ListItemText sx={sxMenuLabel} primary={t("dialog.user.logout")} />
					</ListItemButton>

				</List>

			</Box>
		</Popover>
	</>
}

export default UserButton

const sxMenuLabel:SxProps = {
	"& .MuiListItemText-primary": {
		fontSize: 12,
	},
}

const sxBadgeIcon:SxProps = {
	fontSize: 14,
}